export default "__VITE_ASSET__CBANXdkG__"